// extracted by mini-css-extract-plugin
export default {"title":"create_title__mFVzA","container":"create_container__SgQGO","header":"create_header__Mqran","carrot":"create_carrot__TOcrR"};